namespace TabAurous.OMS {
    export interface RawMaterialMasterForm {
        ProductTypeId: Serenity.LookupEditor;
        CategoryId: CommonCategoryLookup;
        SubCategoryId: CommonSubCategoryLookup;
        ProductCode: Serenity.StringEditor;
        ProductName: Serenity.StringEditor;
        ItemTypeId: Serenity.LookupEditor;
        Attribute: Serenity.StringEditor;
        AttributeId: Serenity.StringEditor;
        PointerWeight: Serenity.DecimalEditor;
        Variance: Serenity.DecimalEditor;
        KaratId: Serenity.LookupEditor;
        Purity: Serenity.DecimalEditor;
        MetalColorId: Serenity.LookupEditor;
        ShapeId: Serenity.LookupEditor;
        StoneColorId: Serenity.LookupEditor;
        QualityId: Serenity.LookupEditor;
        StoneSizeId: StoneSizeLookup;
        SieveId: StoneSieveLookup;
        GroupSieveId: Serenity.IntegerEditor;
        StoneCutId: Serenity.LookupEditor;
        StonePolishId: Serenity.LookupEditor;
        StoneSymmetryId: Serenity.LookupEditor;
        StoneFluorescenceId: Serenity.LookupEditor;
        StoneCuletId: Serenity.LookupEditor;
        StoneGirdleId: Serenity.LookupEditor;
        StoneTable: Serenity.StringEditor;
        StoneDepth: Serenity.StringEditor;
        CalcOnId: Serenity.LookupEditor;
        CalcUnitId: Serenity.LookupEditor;
        CostMethodId: Serenity.LookupEditor;
        HSN: Serenity.LookupEditor;
        TaxCode: Serenity.LookupEditor;
        IsConfigurable: Serenity.BooleanEditor;
        IsDisabled: Serenity.BooleanEditor;
        IsCustomerItem: Serenity.BooleanEditor;
        ForExchange: Serenity.BooleanEditor;
        Rate: Serenity.DecimalEditor;
        SalesPrice: Serenity.DecimalEditor;
        Remarks: Serenity.StringEditor;
        ServerDate: Serenity.DateEditor;
    }

    export class RawMaterialMasterForm extends Serenity.PrefixedContext {
        static formKey = 'OMS.RawMaterialMaster';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!RawMaterialMasterForm.init)  {
                RawMaterialMasterForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = CommonCategoryLookup;
                var w2 = CommonSubCategoryLookup;
                var w3 = s.StringEditor;
                var w4 = s.DecimalEditor;
                var w5 = StoneSizeLookup;
                var w6 = StoneSieveLookup;
                var w7 = s.IntegerEditor;
                var w8 = s.BooleanEditor;
                var w9 = s.DateEditor;

                Q.initFormType(RawMaterialMasterForm, [
                    'ProductTypeId', w0,
                    'CategoryId', w1,
                    'SubCategoryId', w2,
                    'ProductCode', w3,
                    'ProductName', w3,
                    'ItemTypeId', w0,
                    'Attribute', w3,
                    'AttributeId', w3,
                    'PointerWeight', w4,
                    'Variance', w4,
                    'KaratId', w0,
                    'Purity', w4,
                    'MetalColorId', w0,
                    'ShapeId', w0,
                    'StoneColorId', w0,
                    'QualityId', w0,
                    'StoneSizeId', w5,
                    'SieveId', w6,
                    'GroupSieveId', w7,
                    'StoneCutId', w0,
                    'StonePolishId', w0,
                    'StoneSymmetryId', w0,
                    'StoneFluorescenceId', w0,
                    'StoneCuletId', w0,
                    'StoneGirdleId', w0,
                    'StoneTable', w3,
                    'StoneDepth', w3,
                    'CalcOnId', w0,
                    'CalcUnitId', w0,
                    'CostMethodId', w0,
                    'HSN', w0,
                    'TaxCode', w0,
                    'IsConfigurable', w8,
                    'IsDisabled', w8,
                    'IsCustomerItem', w8,
                    'ForExchange', w8,
                    'Rate', w4,
                    'SalesPrice', w4,
                    'Remarks', w3,
                    'ServerDate', w9
                ]);
            }
        }
    }
}
